import { createSlice } from '@reduxjs/toolkit';

const savedTheme = localStorage.getItem('theme');
const initialTheme = savedTheme ? JSON.parse(savedTheme) : 'dark';

export enum Themes {
  Dark = 'dark',
  Light = 'light',
}

interface InitialState {
  theme: Themes;
}

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    theme: initialTheme,
  } as InitialState,

  reducers: {
    themeChanged: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem('theme', JSON.stringify(action.payload));
    },
  },
});

export const { themeChanged } = appSlice.actions;

export default appSlice.reducer;
